import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Search, UserPlus2 } from "lucide-react";
import { listDeptCandidates } from "../../api/departments";
import { localName } from "../../lib/localName";

// شريط بحث يُظهر مرشحين من نفس فرع القسم — ضغط على مرشّح يضيفه فوراً.
export const DepartmentMemberAdd = ({ deptId, existingIds, onAdd }) => {
  const { t, i18n } = useTranslation();
  const isAr = (i18n.language || "ar").startsWith("ar");
  const [query, setQuery] = useState("");
  const [open, setOpen] = useState(false);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (!deptId || !open) return;
    const timer = setTimeout(async () => {
      try { setRows(await listDeptCandidates(deptId, query)); } catch { setRows([]); }
    }, 200);
    return () => clearTimeout(timer);
  }, [deptId, query, open]);

  const filtered = useMemo(
    () => rows.filter((r) => !existingIds.includes(r.id)),
    [rows, existingIds]
  );

  const pick = async (u) => {
    await onAdd(u);
    setQuery("");
    setOpen(false);
  };

  return (
    <div className="relative" data-testid="dept-member-add">
      <div className="relative">
        <Search className="pointer-events-none absolute top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground start-3" />
        <input
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onFocus={() => setOpen(true)}
          onBlur={() => setTimeout(() => setOpen(false), 180)}
          placeholder={t("departments.members.searchPh")}
          className="w-full rounded-2xl border border-border/50 bg-background py-2.5 ps-9 pe-3 text-sm shadow-neu-sm outline-none focus:ring-2 focus:ring-primary/40"
          data-testid="dept-member-add-input"
        />
      </div>
      {open ? (
        <div className="neu absolute inset-x-0 top-full z-10 mt-2 max-h-72 overflow-y-auto p-1" data-testid="dept-member-suggestions">
          {filtered.length === 0 ? (
            <p className="px-3 py-4 text-center text-xs text-muted-foreground">
              {t("departments.members.noneInBranch")}
            </p>
          ) : (
            filtered.map((u) => (
              <button
                key={u.id}
                type="button"
                onMouseDown={(e) => { e.preventDefault(); pick(u); }}
                data-testid={`dept-cand-${u.id}`}
                className="flex w-full items-center gap-3 rounded-2xl px-3 py-2 text-start transition hover:bg-primary/5"
              >
                <UserPlus2 className="h-4 w-4 text-primary" />
                <span className="flex-1 truncate text-xs font-semibold">
                  {localName(u, u.email)}
                </span>
                <span className="text-[10px] text-muted-foreground">{u.email}</span>
              </button>
            ))
          )}
        </div>
      ) : null}
    </div>
  );
};
